import { useState, useEffect, useContext } from "react";
import "./shipping-label.create.modal.css";
import { UserContext } from "../../../../contexts/user.context";
import { ShippingLabelsContext } from "../../../../contexts/shipping-labels.context";
import Loader from "../../../loader/loader.component";

const ShippingLabelCreateModal = ({ show, onHide, onSuccess }) => {
  const { currentUser, getUserAddresses } = useContext(UserContext);
  const { createShippingLabel } = useContext(ShippingLabelsContext);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) return;
    if (!currentUser?.email) return;
    getUserAddresses(currentUser.email).then((res) => {
      if (res?.length) {
        setAddresses(res);
        setSelectedAddress(res[0]);
      }
    });
  }, [show]);

  if (!show) return null;

  const handleAddressChange = (e) => {
    const found = addresses.find((a) => String(a.id) === e.target.value);
    setSelectedAddress(found || null);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const label = await createShippingLabel(selectedAddress);
      if (label?._id) {
        onSuccess(label);
        onHide();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="modal-overlay" onClick={onHide}>
        <div className="modal-box sl-create-modal" onClick={(e) => e.stopPropagation()}>
          <h2 className="modal-title">New Shipping Label</h2>
          <hr />
          <div className="sl-address-field">
            <label>Address</label>
            <select
              value={selectedAddress?.id ?? ""}
              onChange={handleAddressChange}
            >
              {addresses.map((addr) => (
                <option key={addr.id} value={addr.id}>
                  {addr.name} — {addr.address1}
                  {addr.address2 ? `, ${addr.address2}` : ""}, {addr.city},{" "}
                  {addr.state} {addr.zip}
                </option>
              ))}
            </select>
          </div>
          <div className="sl-modal-actions">
            <button className="sl-btn sl-btn-cancel" onClick={onHide} disabled={loading}>Cancel</button>
            <button
              className="sl-btn sl-btn-primary"
              onClick={handleSubmit}
              disabled={!selectedAddress || loading}
            >
              {loading ? "Creating..." : "Create Label"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingLabelCreateModal;
